import React, { useEffect, useState } from "react";
import QRCode from "qrcode";
import { Button } from "@/components/ui/button";
import { Download, Printer } from "lucide-react";

const withTitle = (src, title, size) => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => {
    const c = document.createElement("canvas");
    c.width = size; c.height = size + 70;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, c.width, c.height);
    ctx.drawImage(img, 0, 0, size, size);
    ctx.fillStyle = "#0f172a"; ctx.textAlign = "center";
    ctx.font = `bold ${Math.round(size / 13)}px sans-serif`;
    ctx.fillText(title, size / 2, size + 42, size - 16);
    resolve(c.toDataURL("image/png"));
  };
  img.src = src;
});

export function QrCode({ value, label = "QR Code", size = 260, caption = "", title = "" }) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (!value) return;
    QRCode.toDataURL(value, { width: size, margin: 2, errorCorrectionLevel: "M" })
      .then((src) => (title ? withTitle(src, title, size) : src)).then(setUrl).catch(() => {});
  }, [value, size, title]);

  const download = () => {
    if (!url) return;
    const a = document.createElement("a");
    a.href = url;
    a.download = `${(title || label).replace(/\s+/g, "_")}.png`;
    a.click();
  };
  const print = () => {
    if (!url) return;
    const w = window.open("", "_blank");
    if (!w) return;
    w.document.write(`<html><head><title>${title || label}</title></head><body style="text-align:center;font-family:sans-serif;padding:40px"><h1 style="margin-bottom:8px">${title || label}</h1><img src="${url}" style="width:340px"/><p style="max-width:380px;margin:16px auto;color:#334155">${caption}</p></body></html>`);
    w.document.close();
    w.focus();
    setTimeout(() => w.print(), 350);
  };

  return (
    <div className="inline-flex flex-col items-center gap-3" data-testid="qr-box">
      {url ? <img src={url} alt={title || label} className="rounded-xl border border-slate-200 bg-white p-3" style={{ width: size }} data-testid="qr-image" /> : <div className="text-sm text-slate-400 py-10">Generating…</div>}
      {title && <p className="text-sm font-bold text-slate-900 -mt-1" data-testid="qr-title">{title}</p>}
      <div className="flex gap-2">
        <Button size="sm" variant="outline" onClick={download} data-testid="qr-download"><Download className="h-4 w-4 mr-1" /> Download</Button>
        <Button size="sm" variant="outline" onClick={print} data-testid="qr-print"><Printer className="h-4 w-4 mr-1" /> Print</Button>
      </div>
    </div>
  );
}
